const { CardNames } = require('../Constants/Names/CardNames');

class PlayerStateData {
    constructor(name, playerNumber)
    {
        this.name = name;
        this.playerNumber = playerNumber
        // Starting position from the rulebook: empty hands, 6 workers on the Age A cards, 1 in the pool,
        // and no food or resources yet
        this.militaryHand = [];
        this.civilHand = [];
        this.technologies = [
                {Type: CardNames.TechnologyNames.Military.Warrior, contents: {workers: 1}},
                {Type: CardNames.TechnologyNames.Production.Agriculture, contents: {workers: 2}},
                {Type: CardNames.TechnologyNames.Production.Bronze, contents: {workers: 2}},
                {Type: CardNames.TechnologyNames.Urban.Philosophy, contents: {workers: 1}},
                {Type: CardNames.TechnologyNames.Urban.Religion, contents: {}}
        ];
        // Completed wonders, and the one wonder being built: { card, stagesBuilt }
        this.wonders = [];
        this.wonderInProgress = null;
        // The leader in play, and the ages leaders have been taken from (only one leader per age, ever)
        this.leader = null;
        this.leaderAgesTaken = [];
        // Name of the tactic in use, and the tactic card played into this player's area that is not yet
        // available to everyone (it moves to the common tactics at the start of the player's next turn)
        this.currentTactic = null;
        this.exclusiveTactic = null;
        // Playing and copying a tactic share one use per turn
        this.changedTacticThisTurn = false;
        this.turnFlags = [];
        this.turnPools = [];
        this.turnPoolUsage = {};
        this.turnBonuses = [];
        this.takenThisTurn = [];

        this.workerPool = 1;
        // First round: players start with 1, 2, 3, 4 of Despotism's 4 civil actions in turn order and none of its
        // 2 military actions, shown as already spent (so nobody draws military cards at the end of round 1)
        this.civilActionsUsed = 3 - playerNumber;
        this.militaryActionsUsed = 2;
        this.science = 0;
        this.culture = 0;
        this.government = CardNames.TechnologyNames.Government.Despotism;
        // The blue and yellow banks are worked out from the tokens owned (see PlayerState.blueBank); this holds
        // tokens gained or lost from events and the like
        this.tokenChanges = { blue: [], yellow: [] };
    }
}

module.exports = PlayerStateData;